import { NavLink } from "react-router-dom";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import WorkOrderSearch from "../admin/work-orders-search"; // adjust path

const TopMenu = () => {
  const [showSearchModal, setShowSearchModal] = useState(false);

  const handleOpenSearch = () => setShowSearchModal(true);
  const handleCloseSearch = () => setShowSearchModal(false);

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary py-0">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            {/* LEFT MENU */}
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/work-orders-active">Home</NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/work-orders-new">New Case</NavLink>
              </li>

              {/* Work Order Dropdown */}
                {localStorage.getItem("@admin_role") == 1 && (
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="workOrderDropDown"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  Work Order
                </a>
                <ul className="dropdown-menu">
                  <li><NavLink className="nav-link" to="/admin/work-orders-active">Active</NavLink></li>
                  <li><NavLink className="nav-link" to="/admin/work-orders-records-obtained">Records Obtained</NavLink></li>
                  <li><NavLink className="nav-link" to="/admin/work-orders-closed">Closed</NavLink></li>
                  <li><NavLink className="nav-link" to="/admin/work-orders-archived">Archived</NavLink></li>
                  <li><NavLink className="nav-link" to="/admin/work-orders-canceled">Canceled</NavLink></li>
                  <li><NavLink className="nav-link" to="/admin/work-orders-incomplete">Incomplete</NavLink></li>
                </ul>
              </li>
                )}

              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/patients">Patient</NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/facilities">Facility</NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/clients">Client</NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/administrators">Admin</NavLink>
              </li>

              {localStorage.getItem("@admin_role") == 1 && (
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">
                    Reports
                  </a>
                  <ul className="dropdown-menu">
                    <li><NavLink className="nav-link" to="/admin/report-turnaround">Turnaround</NavLink></li>
                    <li><NavLink className="nav-link" to="/admin/report-weekly">Weekly</NavLink></li>
                    <li><NavLink className="nav-link" to="/admin/report-cost">Avg Cost Client</NavLink></li>
                    <li><NavLink className="nav-link" to="/admin/report-facility-cost">Avg Cost Facility</NavLink></li>
                    <li><NavLink className="nav-link" to="/admin/report-on-hold">On Hold</NavLink></li>
                    <li><NavLink className="nav-link" to="/admin/report-canceled">Canceled</NavLink></li>
                  </ul>
                </li>
              )}

               <li className="nav-item">
                <NavLink className="nav-link" to="/admin/login-logs">Login Logs</NavLink>
              </li>

            </ul>

            {/* RIGHT MENU */}
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <button className="btn btn-light btn-sm" onClick={handleOpenSearch} >Search</button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* SEARCH MODAL */}
      <Modal
        show={showSearchModal}
        onHide={handleCloseSearch}
        size="xl"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Search Work Orders</Modal.Title>
        </Modal.Header>

        <Modal.Body className="bg-light">
          <WorkOrderSearch />
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseSearch}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TopMenu;
